
import i18n from "../../i18n";
import { BASE_END_POINT } from "../../parametros";

async function enviarAlteracaoDeSenha(
    usuario: string,
    senha: string,
    novaSenha: string
): Promise<void> {

    const url = `${BASE_END_POINT}/api-v1/contas/${usuario}/${senha}/${novaSenha}/alteracao-senha`;

    const response = await fetch(url, {
        method: "PATCH",
        headers: {
            'Accept-Language': i18n.language
        }
    });

    if (!response.ok) {
        throw new Error(`Erro ao alterar a senha. Código: ${response.status}`);
    }

    // 204 = sucesso sem conteúdo
    return;
}


export {
    enviarAlteracaoDeSenha
}

